export enum ActivityType {
    IMPORTER = 'IMPORTER',
    DISTRIBUTOR = 'DISTRIBUTOR',
    WHOLESALER = 'WHOLESALER',
    PACKAGER_LABELLER = 'PACKAGER_LABELLER',
    NA_MARKETING_COMPANY_ONLY = 'NA_MARKETING_COMPANY_ONLY',
}
